// 设置私有变量
const color = Symbol('color')
const size = Symbol('size')
const disabled = Symbol('disabled')

/**
 * button 的样式控制器
 * 外部调用时可以自定义样式
 */
class Config {
  constructor () {
    // 默认的颜色样式
    this[color] = {
      blue: 'blue-btn',
      orange: 'orange-btn',
      red: 'red-btn',
      white: 'white-btn',
      gray: 'gray-btn',
      green: 'green-btn',
      transparent: 'transparent-btn'
    }

    // 默认的尺寸样式
    this[size] = {
      small: 'gkui-small-btn',
      normal: 'gkui-normal-btn',
      big: 'gkui-big-btn',
      custom: ''
    }

    // 默认的禁用样式
    this[disabled] = 'disabled-btn'
  }

  /**
   * 设置按钮的颜色样式
   * @param {Map}      options 颜色样式 map
   * @param {Boolean}  merge   合并或者替换默认样式
   */
  setColor (options, merge) {
    this[color] = Object.assign(merge ? this[color] : {}, options)
  }

  /**
   * 获取按钮的颜色样式名
   * @param {String}  sizeName 样式名
   */
  getColor (colorName) {
    return this[color][colorName]
  }

  /**
   * 设置按钮的尺寸样式
   * @param {Map}      options 尺寸样式 map
   * @param {Boolean}  merge   合并或者替换默认样式
   */
  setSize (options, merge) {
    this[size] = Object.assign(merge ? this[size] : {}, options)
  }

  /**
   * 获取按钮的尺寸样式名
   * @param {String}  sizeName 样式名
   */
  getSize (sizeName) {
    return this[size][sizeName]
  }

  /**
   * 设置按钮的禁用样式
   * @param {String}  className 样式名
   */
  setDisabledClassname (className) {
    this[disabled] = className
  }

  /**
   * 获取按钮的禁用样式
   */
  getDisabledClassname () {
    return this[disabled]
  }
}

export default new Config()
